export const features = {
    "template": "template2",
    "companyName": "Innovated Holdings, Inc (UAT)",
    "inowEndpoint": "https://uat-ihi.in.guidewire.net",
    "tokenIssuer": "https://ihi-inow.oktapreview.com/oauth2/default",
    "clientId": "0oa3v6711yzePFH7l1d7",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": false,
        "agentEmail": true,
        "agentLink": true,
        "agentPanel": true,
        "blockAchNumberOps": false,
        "changeCoverage": true,
        "claimDetailsDocuments": true,
        "claimDetailsPayments": true,
        "claimDocumentUpload": true,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": false,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "deactivateUserOnly": true,
        "defaultLossDateTime": false,
        "editPayPlan": true,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2500-01-01",
        "mfaEnabled": true,
        "needHelp": false,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": true,
        "passwordResetInfo": false,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDocumentUpload": true,
        "policyForms": true,
        "policyFormsDownload": true,
        "policyUserAttachmentsDisplay": true,
        "printButtonEnabled": false,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": true,
        "scheduledPayments": true,
        "showImageTag": true,
        "standardPhoneLength": false,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": false,
        "useInsuredAttachments": false,
        "verifyAddress": true,
        "viewChangeRequests": true
    },
    "keys": {
        "googleAnalytics": null,
        "googleAnalytics4": null,
        "googleAnalytics4GwDev": "G-R8Y22B4GYL",
        "googleAnalytics4GwProd": "G-C0D8F7WEDX",
        "googlePlacesApi": "AIzaSyCi2xKl2Zg5aKecTqW1XjYI2oIcUa3Sehg"
    },
    "salesPortalUrl": "",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net/",
    "paymentTenantName": "tenant.ihi",
    "paymentConfigIds": {
        "CNIC": "65054",
        "CFM": "5167001",
        "OMIC": "12092901"
    },
    "paymentMethods": [
        "ACH",
        "CC"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC"
    ],
    "achEntryClassCode": "PPD",
    "processingFee": 4.95,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "20",
    "policiesCountLimit": "20",
    "billingAccountsCountLimit": "20",
    "faviconFileExtension": "ico",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renewed,Non-Renew Requested,Cancel Notice",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 10,
            "message": "Use at least 10 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2020-01-01T17:00-05:00",
        "endTime": "2020-12-31T17:00-05:00"
    },
    "notificationSmsNumber": "123-456-7890",
    "billingStatusCd": "Normal, Cancel, Legal",
    "_meta": {
        "build": "4.0.0-50-4fcd1fa",
        "commit": "4fcd1fac044c55893c1677b9dd7187741de52795",
        "company": "cnic",
        "date": "2025-02-11T15:37:14+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    }
};